import type { ApiStorageTransaction } from '@Model';
import { getStorageTransactionOriginLabel } from '@Model';
import { Button, defaultIconSize, InlineBanner } from '@synqo/frontend-component-library';
import { IconFileText } from '@tabler/icons-react';
import { useOpenOrder } from '../useOpenOrder';
import type { BookingState } from './cancellation';

interface IProps {
    booking: Pick<ApiStorageTransaction, 'origin_order' | 'origin_position' | 'origin_order_deleted'>;
    state: BookingState;
}

/** Names the order and position a booking comes from, with a button to the order unless it is deleted. An effective booking changes only through its order. */
// @ai-generated 2026-10-30T09:00:00Z by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function OrderBookingNotice({ booking, state }: IProps) {
    const openOrder = useOpenOrder();
    const orderId = booking.origin_order.foreign_key;

    return (
        <InlineBanner
            variant="info"
            icon={<IconFileText size={defaultIconSize} />}
            title={`Diese Buchung stammt aus ${getStorageTransactionOriginLabel(booking)}`}
            description={state === 'effective' ? 'Sie ändert sich nur über den Auftrag.' : undefined}
            action={
                orderId &&
                !booking.origin_order_deleted && (
                    <Button appearance="outlined" size="xs" onClick={() => openOrder(orderId)}>
                        Auftrag öffnen
                    </Button>
                )
            }
        />
    );
}
